import React from 'react';

const ProjectStats = ({ stats }) => {
    const formatNumber = (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(2) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(2) + 'K';
        }
        return num.toString();
    };

    const statsData = [
        {
            label: 'Total Endpoints',
            value: stats.totalEndpoints,
            color: 'var(--text-primary)',
        },
        {
            label: 'Total Tests',
            value: stats.totalTests,
            color: 'var(--text-primary)',
        },
        {
            label: 'Total Requests',
            value: formatNumber(stats.totalRequests),
            color: 'var(--text-primary)',
        },
        {
            label: 'Credits Used',
            value: stats.totalCreditsUsed,
            color: 'var(--text-primary)',
        },
    ];

    return (
        <div className="stats-grid">
            {statsData.map((stat, index) => (
                <div key={index} className="stat-card">
                    <div className="stat-label">{stat.label}</div>
                    <div className="stat-value" style={{ color: stat.color }}>
                        {stat.value}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProjectStats;
